// src/emojiMap.js
export const emojiMap = {
  ":)": "😊",
  ":(": "☹️",
  ";)": "😉",
  ":D": "😃",
  ":'(": "😢",
  ":P": "😜",
  "(Y)": "👍",
  "(N)": "👎",
  "<3": "❤️",
  ":*": "😘",
  ":o": "😮",
  ":|": "😐",
  "(6)": "😈",
  "(A)": "😇",
  "(H)": "😎",
  "(L)": "💖",
  "(U)": "💔",
  "(K)": "💋",
  "(!)": "❗",
  "(?)": "❓",
  "(*)": "⭐",
};